export default "__VITE_ASSET__CONNLLPS__"